'use strict';

import angular from 'angular';

import services from '../../services';
import constants from '../../constants';

import saLocationSearchForm from './location_search_form';
import saLocationSearchInput from './location_search_input';
import saLocationSearchPrediction from './location_search_prediction';
import saLocationSearchPredictions from './location_search_predictions';

import highlightLocationPredictionFilter from './location_prediction.filter';

const dependencies = [
  services,
  constants
];

export default angular
  .module('common.locationSearch', dependencies)
  .directive('saLocationSearchForm', saLocationSearchForm)
  .directive('saLocationSearchInput', saLocationSearchInput)
  .directive('saLocationSearchPrediction', saLocationSearchPrediction)
  .directive('saLocationSearchPredictions', saLocationSearchPredictions)
  .filter('highlightLocationPrediction', highlightLocationPredictionFilter)
  .name;



// WEBPACK FOOTER //
// ./app/src/common/location_search/index.js